import { AuthService } from './../../../_services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { MyMessage } from './../../../_models/message';
import { DataUtilService } from './../../../_services/data-util.service';
import { MessageService } from './../../../_services/message.service';
import { Subscription } from './../../../_models/subscription';
import { Student } from './../../../_models/student';
import { Guardian } from './../../../_models/guardian';
import { Component, OnInit } from '@angular/core';
import { StudentService } from 'src/app/_services/student.service';

@Component({
  selector: 'app-student-message-show',
  templateUrl: './student-message-show.component.html',
  styleUrls: ['./student-message-show.component.css']
})
export class StudentMessageShowComponent implements OnInit {
  message= new MyMessage(0,"","",0)

  guardian = new Guardian()
  student = new Student()
  subscription = new Subscription()
  constructor(
    private route:ActivatedRoute,
    private studentService:StudentService,
    public authService:AuthService,
    private messageService:MessageService,
    private dataUtilService:DataUtilService
  ) { }

  ngOnInit(): void {

    this.route.params.subscribe(
      params=>{
        if(params['messageId']){
          this.messageService.getMessageById(params['messageId']).subscribe(
            val=>{
              this.message=val
            }
          )
      }
    }
    )
    if(this.authService.isStudent()){

      this.studentService.getByUserId(this.authService.gatePass.getValue().user_id).subscribe(
        data=>{
          this.initStudent(data)
        }
       )
    }
  }
  initStudent(data){
    if(data!=null){
      if(this.dataUtilService.isGoodResponse(data)){
       this.student= this.dataUtilService.myData(data)
       if(this.student['subscription_object']!=null){
        this.subscription=this.student['subscription_object']
       }
      }
    }
  }
}
